import { useEffect, useState } from 'react';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { coinIcons } from 'shared/constants';
import { NULL_ADDRESS } from 'shared/constants/constants';
import { useCurrenciesStore } from 'shared/store/currenciesStore';
import { useRoomStore } from 'shared/store/roomStore';
import { genericFormatBet } from 'shared/utils/betFormater';
import { getCoinIcon } from 'shared/utils/getCoinIcon';
import { getPrizeImage } from 'shared/utils/getPrizeImage';

import EmptyBox from 'assets/png/boxes/empty.png?format=webp;avif&as=picture';
import fullBox from 'assets/png/boxes/full.png?format=webp;avif&as=picture';

type CoinSymbol = keyof typeof coinIcons;

interface RoomPrizeProps {
  amIWinner: boolean;
  nobodyMakeAmove: boolean;
}

export const MobileRoomPrizeImage = ({ amIWinner, nobodyMakeAmove }: RoomPrizeProps) => {
  const [prizeImage, setPrizeImage] = useState(fullBox);
  const [betText, setBetText] = useState('');
  const { selectedCurrency } = useCurrenciesStore();

  const { bet, playerB } = useRoomStore();
  // prize image
  useEffect(() => {
    if (!amIWinner) {
      setPrizeImage(EmptyBox);
    } else {
      setPrizeImage(getPrizeImage(bet, selectedCurrency, true));
    }
  }, [amIWinner, bet, selectedCurrency]);

  useEffect(() => {
    if (bet) {
      let rawBet = bet;
      if (playerB.address !== NULL_ADDRESS && amIWinner) {
        rawBet = bet * 2;
      }

      let formattedBet = genericFormatBet(rawBet.toString(), 'text-[16px]');

      if (nobodyMakeAmove) {
        setBetText(`+ ${formattedBet}`);
      } else {
        setBetText(`${amIWinner ? `+` : `-`}${formattedBet}`);
      }
    }
  }, [bet, selectedCurrency, playerB, amIWinner]);

  return (
    <>
      <OptimizedImage
        imageData={prizeImage}
        alt="box"
        className="z-40 mx-auto my-auto w-full max-w-[25rem]"
      />
      <div
        className={`absolute bottom-4 left-1/2 z-50 min-w-[11.625rem] -translate-x-1/2 bg-gradient-to-b from-[#FFF] p-[2px] ${amIWinner ? 'to-[#FFC000]' : 'to-[#E81C34]'} rounded-xl`}
      >
        <div
          className={`flex items-center justify-center rounded-xl bg-gradient-to-t ${amIWinner ? 'from-[#250A02] to-[#AA6900]' : 'from-[#020C25] to-[#901826]'} gap-1.5 py-2.5`}
        >
          <span
            className="text-[24px] font-bold leading-[26px] text-white"
            dangerouslySetInnerHTML={{ __html: betText }}
          />
          {getCoinIcon(
            selectedCurrency?.symbol as CoinSymbol | undefined,
            'h-auto max-h-6 w-auto max-w-6',
          )}
        </div>
      </div>
    </>
  );
};
